import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);

  const users = [
  {
    id: 1,
    name: "John Mitchell",
    email: "john.mitchell@cranedealer.com",
    role: "dealer_pro",
    status: "Active",
    subscription: "Dealer Pro",
    lastLogin: "2025-11-06 14:30",
    registeredDate: "2024-08-15",
    usageCount: 847,
    monthlyQuota: "Unlimited",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e416f65d-1762274311043.png",
    avatarAlt: "Professional headshot of middle-aged man with gray hair in business suit"
  },
  {
    id: 2,
    name: "Sarah Chen",
    email: "s.chen@financecorp.com",
    role: "lender_pro",
    status: "Active",
    subscription: "Lender Pro",
    lastLogin: "2025-11-06 09:15",
    registeredDate: "2024-09-22",
    usageCount: 1234,
    monthlyQuota: "Unlimited",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19dc77a7e-1762274545448.png",
    avatarAlt: "Professional headshot of Asian woman with black hair in navy blazer"
  },
  {
    id: 3,
    name: "Mike Rodriguez",
    email: "mike.r@equipment-rental.com",
    role: "user",
    status: "Active",
    subscription: "Free",
    lastLogin: "2025-11-05 16:45",
    registeredDate: "2025-10-01",
    usageCount: 2,
    monthlyQuota: "3/month",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_146519534-1762248826013.png",
    avatarAlt: "Professional headshot of Hispanic man with short black hair in casual shirt"
  },
  {
    id: 4,
    name: "Emily Johnson",
    email: "emily.johnson@constructionco.com",
    role: "dealer_pro",
    status: "Suspended",
    subscription: "Dealer Pro",
    lastLogin: "2025-10-28 11:20",
    registeredDate: "2024-06-10",
    usageCount: 456,
    monthlyQuota: "Unlimited",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10c75be77-1762273997956.png",
    avatarAlt: "Professional headshot of blonde woman in white business shirt"
  }];


  const roleOptions = [
  { value: '', label: 'All Roles' },
  { value: 'admin', label: 'Admin' },
  { value: 'lender_pro', label: 'Lender Pro' },
  { value: 'dealer_pro', label: 'Dealer Pro' },
  { value: 'user', label: 'Free User' }];


  const statusOptions = [
  { value: '', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Suspended', label: 'Suspended' },
  { value: 'Inactive', label: 'Inactive' }];


  const filteredUsers = users?.filter((user) => {
    const matchesSearch = user?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    user?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesRole = !selectedRole || user?.role === selectedRole;
    const matchesStatus = !selectedStatus || user?.status === selectedStatus;
    return matchesSearch && matchesRole && matchesStatus;
  });

  const handleUserSelect = (userId) => {
    setSelectedUsers((prev) =>
    prev?.includes(userId) ?
    prev?.filter((id) => id !== userId) :
    [...prev, userId]
    );
  };

  const handleSelectAll = () => {
    if (selectedUsers?.length === filteredUsers?.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(filteredUsers?.map((user) => user?.id));
    }
  };

  const handleRoleChange = (userId, newRole) => {
    console.log('Changing role for user:', userId, 'to:', newRole);
  };

  const handleStatusChange = (userId, newStatus) => {
    console.log('Changing status for user:', userId, 'to:', newStatus);
  };

  const handleBulkAction = (action) => {
    console.log('Bulk action:', action, 'for users:', selectedUsers);
  };

  const handleExportUsers = () => {
    console.log('Exporting user data');
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'admin':return 'bg-primary/10 text-primary';
      case 'lender_pro':return 'bg-accent/10 text-accent';
      case 'dealer_pro':return 'bg-success/10 text-success';
      case 'user':return 'bg-muted text-text-secondary';
      default:return 'bg-muted text-text-secondary';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':return 'bg-success/10 text-success';
      case 'Suspended':return 'bg-warning/10 text-warning';
      case 'Inactive':return 'bg-error/10 text-error';
      default:return 'bg-muted text-text-secondary';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header Actions */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Search by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              className="w-full" />

          </div>
          <div className="w-full sm:w-40">
            <Select
              options={roleOptions}
              value={selectedRole}
              onChange={setSelectedRole}
              placeholder="Filter by role" />

          </div>
          <div className="w-full sm:w-40">
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={setSelectedStatus}
              placeholder="Filter by status" />

          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            onClick={handleExportUsers}
            iconName="Download"
            iconPosition="left"
            size="sm">

            Export Users
          </Button>
        </div>
      </div>
      {/* Bulk Actions */}
      {selectedUsers?.length > 0 &&
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-sm text-text-primary">
              {selectedUsers?.length} user{selectedUsers?.length > 1 ? 's' : ''} selected
            </p>
            <div className="flex flex-wrap gap-2">
              <Button
              variant="outline"
              size="sm"
              onClick={() => handleBulkAction('suspend')}
              iconName="Pause"
              iconPosition="left">

                Suspend
              </Button>
              <Button
              variant="outline"
              size="sm"
              onClick={() => handleBulkAction('activate')}
              iconName="Play"
              iconPosition="left">

                Activate
              </Button>
              <Button
              variant="outline"
              size="sm"
              onClick={() => handleBulkAction('export')}
              iconName="Download"
              iconPosition="left">

                Export Selected
              </Button>
            </div>
          </div>
        </div>
      }
      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Users" size={20} className="text-primary" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Total Users</p>
              <p className="text-2xl font-semibold text-text-primary">2,847</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
              <Icon name="Crown" size={20} className="text-success" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Pro Subscribers</p>
              <p className="text-2xl font-semibold text-text-primary">1,234</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="Activity" size={20} className="text-accent" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Active Today</p>
              <p className="text-2xl font-semibold text-text-primary">456</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-warning" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Suspended</p>
              <p className="text-2xl font-semibold text-text-primary">23</p>
            </div>
          </div>
        </div>
      </div>
      {/* Users Table */}
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted">
              <tr>
                <th className="text-left p-4">
                  <input
                    type="checkbox"
                    checked={selectedUsers?.length === filteredUsers?.length && filteredUsers?.length > 0}
                    onChange={handleSelectAll}
                    className="rounded border-border" />

                </th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">User</th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">Role</th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">Status</th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">Subscription</th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">Usage</th>
                <th className="text-left p-4 text-sm font-medium text-text-primary">Last Login</th>
                <th className="text-right p-4 text-sm font-medium text-text-primary">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers?.map((user) =>
              <tr key={user?.id} className="border-t border-border hover:bg-muted/50">
                  <td className="p-4">
                    <input
                    type="checkbox"
                    checked={selectedUsers?.includes(user?.id)}
                    onChange={() => handleUserSelect(user?.id)}
                    className="rounded border-border" />

                  </td>
                  <td className="p-4">
                    <div className="flex items-center space-x-3">
                      <img
                      src={user?.avatar}
                      alt={user?.avatarAlt}
                      className="w-10 h-10 rounded-full object-cover" />

                      <div>
                        <p className="font-medium text-text-primary">{user?.name}</p>
                        <p className="text-sm text-text-secondary">{user?.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="p-4">
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getRoleColor(user?.role)}`}>
                      {user?.role?.replace('_', ' ')?.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4">
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(user?.status)}`}>
                      {user?.status}
                    </span>
                  </td>
                  <td className="p-4">
                    <div>
                      <p className="text-sm text-text-primary">{user?.subscription}</p>
                      <p className="text-xs text-text-secondary">Since {user?.registeredDate}</p>
                    </div>
                  </td>
                  <td className="p-4">
                    <div>
                      <p className="text-sm text-text-primary">{user?.usageCount?.toLocaleString()}</p>
                      <p className="text-xs text-text-secondary">{user?.monthlyQuota}</p>
                    </div>
                  </td>
                  <td className="p-4">
                    <span className="text-sm text-text-secondary">{user?.lastLogin}</span>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center justify-end space-x-2">
                      <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => console.log('View user details:', user?.id)}
                      iconName="Eye" />

                      <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => console.log('Edit user:', user?.id)}
                      iconName="Edit" />

                      <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => handleStatusChange(user?.id, user?.status === 'Active' ? 'Suspended' : 'Active')}
                      iconName={user?.status === 'Active' ? 'Pause' : 'Play'}
                      className={user?.status === 'Active' ? 'text-warning hover:text-warning' : 'text-success hover:text-success'} />

                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* Pagination */}
      <div className="flex items-center justify-between">
        <p className="text-sm text-text-secondary">
          Showing {filteredUsers?.length} of 2,847 users
        </p>
        <div className="flex items-center space-x-2">
          <Button variant="outline" size="sm" iconName="ChevronLeft">
            Previous
          </Button>
          <Button variant="outline" size="sm">1</Button>
          <Button variant="default" size="sm">2</Button>
          <Button variant="outline" size="sm">3</Button>
          <Button variant="outline" size="sm" iconName="ChevronRight">
            Next
          </Button>
        </div>
      </div>
    </div>);

};

export default UserManagement;